export default "__VITE_ASSET__CbmUXSn3__"